const skills = [
  {
      "category": "Backend Development",
      "items": [
        { "name": "Java", "level": "Expert", "score": 5 },
        { "name": "Spring Boot", "level": "Advanced", "score": 4 },
        { "name": "J2EE", "level": "Advanced", "score": 4 },
        { "name": "RESTful APIs", "level": "Advanced", "score": 4 },
        { "name": "Microservices Architecture", "level": "Advanced", "score": 4 }
      ]
    },
    {
      "category": "Frontend Development",
      "items": [
        { "name": "ReactJS", "level": "Advanced", "score": 4 },
        { "name": "JavaScript", "level": "Advanced", "score": 4 },
        { "name": "HTML5", "level": "Advanced", "score": 4 },
        { "name": "CSS3", "level": "Intermediate", "score": 3 }
      ]
    },
    {
      "category": "Databases",
      "items": [
        { "name": "PostgreSQL", "level": "Advanced", "score": 4 },
        { "name": "MySQL", "level": "Advanced", "score": 4 },
        { "name": "Oracle", "level": "Advanced", "score": 4 },
        { "name": "MSSQL", "level": "Intermediate", "score": 3 },
        { "name": "MongoDB", "level": "Intermediate", "score": 3 }
      ]
    },
    {
      "category": "DevOps & CI/CD",
      "items": [
        { "name": "Jenkins", "level": "Advanced", "score": 4 },
        { "name": "GitLab CI/CD", "level": "Advanced", "score": 4 },
        { "name": "Docker", "level": "Advanced", "score": 4 },
        { "name": "Kubernetes", "level": "Intermediate", "score": 3 }
      ]
    },
    {
      "category": "Cloud Platforms",
      "items": [
        { "name": "AWS", "level": "Advanced", "score": 4 },
        { "name": "Microsoft Azure", "level": "Intermediate", "score": 3 }
      ]
    },
    {
      "category": "Methodologies",
      "items": [
        { "name": "Agile (Scrum, Kanban)", "level": "Advanced", "score": 4 }
      ]
    },
    {
      "category": "Project Management",
      "items": [
        { "name": "Resource Planning", "level": "Advanced", "score": 4 },
        { "name": "Stakeholder Communication", "level": "Advanced", "score": 4 }
      ]
    },
    {
      "category": "Software Engineering Practices",
      "items": [
        { "name": "Code Reviews", "level": "Advanced", "score": 4 },
        { "name": "Performance Optimization", "level": "Advanced", "score": 4 },
        { "name": "Security Best Practices", "level": "Advanced", "score": 4 }
      ]
    }
];

export {skills};